import { Navigate } from "react-router-dom";

import {
    AdminLayout,
    AdminProjects,
    Dashboard,
    Users,
    ItSupport,
    ItSupportDetails,
    Biometric,
    BiometricDetails,
    BiometricVerifier,
    BiometricVerifierDetails,
    UserDetails,
    ContentDetails,
    Masters,
    MasterDetails,
    Login,
    Content,
    ContentConfiguration,
    ContentPreview,
    EnableExam,
    ScoreManagement,
    CustomerDashboard,
    CustomerMockExam,
    CustomerLiveExam,
    CustomerChart,
    UploadLayout,
    FeedbackPreview,
    ContentDashboardLayout,
    Documents,
    UpdateTime,
    UnlockCandidate,
    MacIds,
    ChangePassword,
    ResetPassword,
    DescriptiveContentPreview,
    FeedbackUpload,
    InstructionsUpload,
    ViewContentConfiguration,
    Candidates,
    ExamSummary,
    ServerSummary,
    Reports,
    BiometricEnrollment,
    CandidateShortlist,
    BiometricReports,
    ObjectionTracker,
    ObjectionTrackerDetails,
    CandidateLists,
} from "../Modules/Admin";
// import { Login } from "../Modules/Shared";
import AdminAuthGuard from './AdminAuthGuard';
import ContentAdminGuard from './ContentAdminGuard';
import BackOfficeAuthGuard from "./BackOfficeAuthGuard";
// import { InstructionsUpload } from "../Modules/Admin/Components/InstructionsUpload/InstructionsUpload";
import CustomerAuthGuard from "./CustomerAuthGuard";
// import AdminProjectGuard from "./AdminProjectGuard";


export const AdminRoutes = [
    // {
    //     path: '/project',
    //     element: <Navigate to='/project/project' />
    // },
    {
        path: ':projectName',
        element: <AdminLayout />,
        children: [
            {
                path: '',
                element: <AdminProjects />,
            },
            {
                path: 'login',
                element: <Login />
            },
            {
                path: 'reset-password',
                element: <ResetPassword />
            },
            {
                path: 'change-password',
                element: <AdminAuthGuard allowedTypes={[2, 3, 4, 5, 6, 7, 8, 9]} allowedModules={[101, 102, 103, 104]} component={<ChangePassword />} />
            },
            // {
            //     path: 'menu-options',
            //     element: <AdminAuthGuard allowedTypes={[2]} component={<MenuOptions />} />
            // },
            {
                path: 'dashboard',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<Dashboard />} />
            },
            {
                path: 'exam-summary',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<ExamSummary />} />
            },
            {
                path: 'server-summary',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[104]} component={<ServerSummary />} />
            },
            {
                path: 'masters',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Masters />} />
            },
            {
                path:'candidate-users',
                element: <AdminAuthGuard allowedTypes={[2]} component={<CandidateLists />} />

            },
            {
                path: 'masters/master-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<MasterDetails />} />
            },
            {
                path: 'candidates',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Candidates />} />
            },
            {
                path: 'users',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Users />} />
            },
            {
                path: 'users/user-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<UserDetails />} />
            },
            {
                path: 'content',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Content />} />
            },
            {
                path: 'content/content-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ContentDetails />} />
            },
            {
                path: 'it-support',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ItSupport />} />
            },
            {
                path: 'it-support/it-support-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ItSupportDetails />} />
            },
            {
                path: 'biometric',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Biometric />} />
            },
            {
                path: 'biometric/biometric-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<BiometricDetails />} />
            },
            {
                path: 'biometric-verifier',
                element: <AdminAuthGuard allowedTypes={[2]} component={<BiometricVerifier />} />
            },
            {
                path: 'biometric-verifier/biometric-verifier-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<BiometricVerifierDetails />} />
            },
            {
                path: 'objection-tracker',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ObjectionTracker />} />
            },
            {
                path: 'objection-tracker/objection-tracker-details',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ObjectionTrackerDetails />} />
            },
            {
                path: 'documents',
                element: <AdminAuthGuard allowedTypes={[2]} component={<Documents />} />
            },
            {
                path: 'update-time',
                element: <AdminAuthGuard allowedTypes={[2]} component={<UpdateTime />} />
            },
            {
                path: 'unlock-candidate',
                element: <AdminAuthGuard allowedTypes={[2]} component={<UnlockCandidate />} />
            },
            {
                path: 'mac-ids',
                element: <AdminAuthGuard allowedTypes={[2, 3]} allowedModules={[102]} component={<MacIds />} />
            },
            {
                path: 'candidate-shortlist',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[103]} component={<CandidateShortlist />} />
            },
            {
                path: 'reports',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[103]} component={<Reports />} />
            },
            {
                path: 'biometric-reports',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[103]} component={<BiometricReports />} />
            },
            {
                path: 'content-configuration',
                element: <AdminAuthGuard allowedTypes={[2]} component={<ContentConfiguration />} />
            },
            {
                path: 'feedback-upload',
                element: <AdminAuthGuard allowedTypes={[2]} component={<FeedbackUpload />} />
            },
            {
                path: 'feedback-preview',
                element: <AdminAuthGuard allowedTypes={[2]} component={<FeedbackPreview />} />
            },
            {
                path: 'instructions-upload',
                element: <AdminAuthGuard allowedTypes={[2]} component={<InstructionsUpload />} />
            },
            {
                path: 'content-dashboard',
                element: <AdminAuthGuard allowedTypes={[3, 4]} allowedModules={[101]} component={<ContentDashboardLayout />} />
            },
            {
                path: 'upload',
                element: <AdminAuthGuard allowedTypes={[4]} component={<UploadLayout />} />
            },
            {
                path: 'upload/view-configuration',
                element: <AdminAuthGuard allowedTypes={[4]} component={<ViewContentConfiguration />} />
            },
            {
                path: 'upload/content-preview',
                element: <AdminAuthGuard allowedTypes={[4]} component={<ContentPreview />} />
            },
            {
                path: 'upload/descriptive-content-preview',
                element: <AdminAuthGuard allowedTypes={[4]} component={<DescriptiveContentPreview />} />
            },
            {
                path: 'enable-exam',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[101]} component={<EnableExam />} />
            },
            {
                path: 'score-management',
                element: <AdminAuthGuard allowedTypes={[3]} allowedModules={[103]} component={<ScoreManagement />} />
            },
            {
                path: 'biometric-enrollment',
                element: <AdminAuthGuard allowedTypes={[8]} component={<BiometricEnrollment />} />
            },
            {
                path: 'customer',
                children: [
                    {
                        path: '',
                        element: <Navigate to='dashboard' />
                    },
                    {
                        path: 'dashboard',
                        // element: <CustomerAuthGuard component={<CustomerDashboard />} />
                        element: <CustomerAuthGuard component={<Dashboard />} />
                    },
                    {
                        path: 'chart',
                        element: <CustomerChart />
                    },
                    {
                        path: 'mock-exam',
                        element: <CustomerMockExam />
                    },
                    {
                        path: 'live-exam',
                        element: <CustomerLiveExam />
                    }
                ]
            },
        ]
    }
];
